export default __webpack_public_path__ + "static/media/img_05.a04d748d.webp";